/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMerchant} from '../api'

 export const useQueryGetMerchant = createReactQueryHook('getMerchant', getMerchant)
